import projectService from "@/service/project-service"

const defaultSchedulerConf = () => ({
  hours: {
    AFTER_MIDNIGHT: {
      order: 1,
      text: "After midnight",
      schedule: { from: "00:00", to: "05:59" }
    },
    BREAKFAST: {
      order: 2,
      text: "Breakfast",
      schedule: { from: "06:00", to: "10:44" }
    },
    LUNCH: {
      order: 3,
      text: "Lunch time",
      schedule: { from: "10:45", to: "14:14" }
    },
    AFTERNOON: {
      order: 4,
      text: "Afternoon",
      schedule: { from: "14:15", to: "17:44" }
    },
    DINNER: {
      order: 5,
      text: "Dinner",
      schedule: { from: "17:45", to: "20:59" }
    },
    BEFORE_MIDNIGHT: {
      order: 6,
      text: "Before midnight",
      schedule: { from: "21:00", to: "23:59" }
    }
  },
  days: {
    MONDAY: { text: "Monday", weekday: 1, order: 1 },
    TUESDAY: { text: "Tuesday", weekday: 2, order: 2 },
    WEDNESDAY: { text: "Wednesday", weekday: 3, order: 3 },
    THURSDAY: { text: "Thursday", weekday: 4, order: 4 },
    FRIDAY: { text: "Friday", weekday: 5, order: 5 },
    SATURDAY: { text: "Saturday", weekday: 6, order: 6 },
    SUNDAY: { text: "Sunday", weekday: 0, order: 7 }
  }
})

function sortSchedulingConf(conf) {
  const sorted = Object.keys(conf)
    .map(key => ({ id: key, ...conf[key] }))
    .sort((a, b) => a.order - b.order)
  return sorted.reduce((acc, item) => {
    acc[item.id] = item
    return acc
  }, {})
}

const VALUES_SEPARATOR = ","

function parseScheduling(schedlingStr = "") {
  return schedlingStr
    .split(VALUES_SEPARATOR)
    .filter(el => el.length != 0)
    .reduce((acc, item) => {
      acc[item] = true
      return acc
    }, {})
}

function stringifyScheduling(scheduling) {
  return Object.keys(scheduling).join(VALUES_SEPARATOR)
}

export default {
  schedulingRef(projectId) {
    return projectService.projectDataRef(projectId).child("offersScheduling")
  },

  schedulingConfRef(projectId) {
    return projectService
      .projectDataRef(projectId)
      .child("offersSchedulingConf")
  },

  schedulingConfHoursRef(projectId) {
    return this.schedulingConfRef(projectId).child("hours")
  },

  onSchedulingChanged(projectId, callback, errorCallback) {
    this.schedulingRef(projectId).on(
      "value",
      snapshot => {
        const scheduling = snapshot.val() || {}
        Object.keys(scheduling).forEach(offerId => {
          scheduling[offerId].days = parseScheduling(scheduling[offerId].days)
          scheduling[offerId].hours = parseScheduling(scheduling[offerId].hours)
        })
        callback(scheduling)
      },
      errorCallback
    )
  },

  onSchedulingConfChanged(projectId, callback, errorCallback) {
    this.schedulingConfRef(projectId).on(
      "value",
      snapshot => {
        const conf = snapshot.val() || {}
        conf.hours = sortSchedulingConf(conf.hours || {})
        conf.days = sortSchedulingConf(conf.days || {})
        callback(conf)
      },
      errorCallback
    )
  },

  saveOfferScheduling(projectId, offerId, offerScheduling) {
    const scheduling = {
      alwaysActive: offerScheduling.alwaysActive,
      hours: stringifyScheduling(offerScheduling.hours),
      days: stringifyScheduling(offerScheduling.days)
    }
    return this.schedulingRef(projectId)
      .child(offerId)
      .set(scheduling)
  },

  removeOfferScheduling(projectId, offerId) {
    return this.schedulingRef(projectId)
      .child(offerId)
      .set(null)
  },

  async saveSchedulingConfHour(projectId, hour) {
    hour.id = hour.id || this.schedulingConfHoursRef(projectId).push().key
    await this.schedulingConfHoursRef(projectId)
      .child(hour.id)
      .set(hour)
    return hour
  },

  removeSchedulingConfHour(projectId, hourId) {
    return this.schedulingConfHoursRef(projectId)
      .child(hourId)
      .set(null)
  },

  removeHourFromScheduling(projectId, scheduling, hourId) {
    return Promise.all(
      Object.keys(scheduling)
        .filter(
          offerId =>
            scheduling[offerId].hours && scheduling[offerId].hours[hourId]
        )
        .map(offerId => {
          const offerScheduling = { ...scheduling[offerId] }
          delete offerScheduling.hours[hourId]
          return this.saveOfferScheduling(projectId, offerId, offerScheduling)
        })
    )
  },

  async createSchedulingConf(projectId) {
    const conf = defaultSchedulerConf()
    await this.schedulingConfRef(projectId).set(conf)
    return conf
  },

  offSchedulingChanged(projectId) {
    this.schedulingRef(projectId).off()
  },

  offSchedulingConfChanged(projectId) {
    this.schedulingConfRef(projectId).off()
  }
}
